(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ascendant-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const signOrder = [
      'berbec',
      'taur',
      'gemeni',
      'rac',
      'leu',
      'fecioara',
      'balanta',
      'scorpion',
      'sagetator',
      'capricorn',
      'varsator',
      'pesti'
    ];
    const glyphs = ['♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓'];
    const elements = [
      'fire',
      'earth',
      'air',
      'water',
      'fire',
      'earth',
      'air',
      'water',
      'fire',
      'earth',
      'air',
      'water'
    ];
    const radians = Math.PI / 180;
    const placeDataCache = new Map();

    const normalizeDegrees = (value) => ((value % 360) + 360) % 360;

    const replaceTokens = (template, values) =>
      Object.entries(values).reduce(
        (result, [token, value]) => result.replaceAll(`__${token}__`, String(value)),
        template
      );

    const foldText = (value) =>
      String(value || '')
        .replaceAll('ş', 'ș')
        .replaceAll('Ş', 'Ș')
        .replaceAll('ţ', 'ț')
        .replaceAll('Ţ', 'Ț')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('ro-RO')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const loadPlaceData = (url) => {
      if (!placeDataCache.has(url)) {
        const request = fetch(url, {
          method: 'GET',
          headers: { Accept: 'application/json' }
        })
          .then((response) => {
            if (!response.ok) throw new Error('location-data-failed');
            return response.json();
          })
          .then((payload) => {
            if (!Array.isArray(payload.places)) throw new Error('location-data-invalid');
            const timezone = payload.timezone || 'Europe/Bucharest';
            return payload.places.map(([name, county, latitude, longitude]) => ({
              name,
              admin1: county === name ? '' : county,
              country: 'România',
              latitude,
              longitude,
              timezone,
              searchName: foldText(name),
              searchCounty: foldText(county)
            }));
          });
        placeDataCache.set(url, request);
      }
      return placeDataCache.get(url);
    };

    const localDateValue = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const zoneParts = (timestamp, timeZone) => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date(timestamp));

      return Object.fromEntries(
        parts
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );
    };

    const zoneOffset = (timestamp, timeZone) => {
      const parts = zoneParts(timestamp, timeZone);
      return (
        Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) -
        timestamp
      );
    };

    const sameWallTime = (parts, wall) =>
      parts.year === wall.year &&
      parts.month === wall.month &&
      parts.day === wall.day &&
      parts.hour === wall.hour &&
      parts.minute === wall.minute;

    const wallTimeToUtc = (wall, timeZone) => {
      const wallTimestamp = Date.UTC(
        wall.year,
        wall.month - 1,
        wall.day,
        wall.hour,
        wall.minute,
        0
      );
      const sampleTimes = [
        wallTimestamp - 43200000,
        wallTimestamp,
        wallTimestamp + 43200000
      ];
      const offsets = [...new Set(sampleTimes.map((timestamp) => zoneOffset(timestamp, timeZone)))];
      const candidates = offsets
        .map((offset) => wallTimestamp - offset)
        .filter((timestamp) => sameWallTime(zoneParts(timestamp, timeZone), wall));

      return [...new Set(candidates)].sort((first, second) => first - second);
    };

    const astronomicalPositions = (utcTimestamp, latitude, longitude) => {
      const julianDay = utcTimestamp / 86400000 + 2440587.5;
      const centuries = (julianDay - 2451545) / 36525;
      const greenwichSidereal = normalizeDegrees(
        280.46061837 +
          360.98564736629 * (julianDay - 2451545) +
          0.000387933 * centuries * centuries -
          (centuries * centuries * centuries) / 38710000
      );
      const localSidereal = normalizeDegrees(greenwichSidereal + longitude);
      const obliquity =
        23.439291111 -
        0.013004167 * centuries -
        0.000000163889 * centuries * centuries +
        0.000000503611 * centuries * centuries * centuries;
      const ascendant = normalizeDegrees(
        Math.atan2(
          -Math.cos(localSidereal * radians),
          Math.sin(obliquity * radians) * Math.tan(latitude * radians) +
            Math.cos(obliquity * radians) * Math.sin(localSidereal * radians)
        ) /
          radians +
          180
      );
      const days = julianDay - 2451545;
      const meanLongitude = normalizeDegrees(280.46 + 0.9856474 * days);
      const meanAnomaly = normalizeDegrees(357.528 + 0.9856003 * days);
      const sunLongitude = normalizeDegrees(
        meanLongitude +
          1.915 * Math.sin(meanAnomaly * radians) +
          0.02 * Math.sin(2 * meanAnomaly * radians)
      );

      return { ascendant, sunLongitude };
    };

    const formattedDegree = (longitude) => {
      const withinSign = normalizeDegrees(longitude) % 30;
      const totalMinutes = Math.min(1799, Math.round(withinSign * 60));
      const degrees = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${degrees}° ${String(minutes).padStart(2, '0')}′`;
    };

    const locationLabel = (location) => {
      const values = [location.name, location.admin1, location.country].filter(Boolean);
      return [...new Set(values)].join(', ');
    };

    const validTimeZone = (timeZone) => {
      try {
        new Intl.DateTimeFormat('en-US', { timeZone }).format();
        return true;
      } catch {
        return false;
      }
    };

    const productHasContent = (product) => Boolean(product && product.url && product.title);

    const initAscendantCalculator = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const slot = document.getElementById('ascendant-calculator-slot');
      if (slot && !slot.contains(root)) {
        const wrapper = root.closest('.shopify-section') || root;
        slot.appendChild(wrapper);
      }

      const config = JSON.parse(root.querySelector('[data-ascendant-config]').textContent);
      const form = root.querySelector('[data-ascendant-form]');
      const birthDate = root.querySelector('[data-birth-date]');
      const birthTime = root.querySelector('[data-birth-time]');
      const approximateTime = root.querySelector('[data-approximate-time]');
      const locationInput = root.querySelector('[data-location-input]');
      const locationList = root.querySelector('[data-location-list]');
      const locationStatus = root.querySelector('[data-location-status]');
      const selectedLocationBox = root.querySelector('[data-selected-location]');
      const selectedLocationName = root.querySelector('[data-selected-location-name]');
      const searchIndicator = root.querySelector('[data-search-indicator]');
      const latitudeInput = root.querySelector('[data-latitude]');
      const longitudeInput = root.querySelector('[data-longitude]');
      const timezoneInput = root.querySelector('[data-timezone]');
      const error = root.querySelector('[data-form-error]');
      const calculateButton = root.querySelector('[data-calculate-button]');
      const buttonLabel = root.querySelector('[data-button-label]');
      const result = root.querySelector('[data-ascendant-result]');
      const productCards = [...root.querySelectorAll('[data-product-card]')];
      let selectedLocation = null;
      let suggestions = [];
      let activeSuggestion = -1;
      let searchTimer = null;
      let searchRequest = 0;
      let lastResult = null;

      birthDate.max = localDateValue(new Date());

      const clearError = () => {
        error.textContent = '';
        error.hidden = true;
      };

      const showError = (message) => {
        error.textContent = message;
        error.hidden = false;
      };

      const setLoading = (loading) => {
        calculateButton.disabled = loading;
        buttonLabel.textContent = loading ? config.copy.calculating : config.copy.calculate;
      };

      const closeSuggestions = () => {
        locationList.hidden = true;
        locationInput.setAttribute('aria-expanded', 'false');
        locationInput.removeAttribute('aria-activedescendant');
        activeSuggestion = -1;
      };

      const setActiveSuggestion = (index) => {
        const options = [...locationList.querySelectorAll('[role="option"]')];
        if (!options.length) return;
        activeSuggestion = (index + options.length) % options.length;
        options.forEach((option, optionIndex) => {
          option.setAttribute('aria-selected', String(optionIndex === activeSuggestion));
        });
        const activeOption = options[activeSuggestion];
        locationInput.setAttribute('aria-activedescendant', activeOption.id);
        activeOption.scrollIntoView({ block: 'nearest' });
      };

      const applyLocation = (location) => {
        selectedLocation = location;
        const label = locationLabel(location);
        locationInput.value = label;
        selectedLocationName.textContent = label;
        selectedLocationBox.hidden = false;
        latitudeInput.value = String(location.latitude);
        longitudeInput.value = String(location.longitude);
        timezoneInput.value = location.timezone;
        locationStatus.textContent = '';
        closeSuggestions();
        clearError();
      };

      const renderSuggestions = () => {
        locationList.replaceChildren();
        suggestions.forEach((location, index) => {
          const option = document.createElement('li');
          const primary = document.createElement('strong');
          const secondary = document.createElement('span');
          const detailValues = [location.admin1, location.country].filter(Boolean);

          option.id = `${root.id}-LocationOption-${index}`;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          primary.textContent = location.name;
          secondary.textContent = [...new Set(detailValues)].join(', ');
          option.append(primary, secondary);
          option.addEventListener('mousedown', (event) => {
            event.preventDefault();
            applyLocation(location);
          });
          locationList.appendChild(option);
        });

        locationList.hidden = suggestions.length === 0;
        locationInput.setAttribute('aria-expanded', String(suggestions.length > 0));
        if (suggestions.length) setActiveSuggestion(0);
      };

      const searchLocations = async (query) => {
        const requestId = ++searchRequest;
        searchIndicator.classList.add('is-loading');
        locationStatus.textContent = '';

        try {
          const normalizedQuery = foldText(query);
          const places = await loadPlaceData(config.placesUrl);
          if (requestId !== searchRequest) return;

          suggestions = places
            .map((place) => {
              const combined = `${place.searchName} ${place.searchCounty}`;
              let score = 99;
              if (place.searchName === normalizedQuery) score = 0;
              else if (place.searchName.startsWith(normalizedQuery)) score = 1;
              else if (
                place.searchName.split(' ').some((word) => word.startsWith(normalizedQuery))
              ) {
                score = 2;
              } else if (combined.includes(normalizedQuery)) score = 3;
              return { place, score };
            })
            .filter(({ score }) => score < 99)
            .sort(
              (first, second) =>
                first.score - second.score ||
                first.place.name.length - second.place.name.length ||
                first.place.name.localeCompare(second.place.name, 'ro-RO')
            )
            .slice(0, 8)
            .map(({ place }) => place);
          renderSuggestions();
          if (!suggestions.length) locationStatus.textContent = config.copy.errorNoResults;
        } catch {
          if (requestId !== searchRequest) return;
          suggestions = [];
          closeSuggestions();
          locationStatus.textContent = config.copy.errorSearch;
        } finally {
          if (requestId === searchRequest) {
            searchIndicator.classList.remove('is-loading');
          }
        }
      };

      const manualLocation = () => {
        const latitude = Number(latitudeInput.value);
        const longitude = Number(longitudeInput.value);
        const timeZone = timezoneInput.value.trim();
        const complete =
          latitudeInput.value !== '' &&
          longitudeInput.value !== '' &&
          timeZone !== '' &&
          Number.isFinite(latitude) &&
          Number.isFinite(longitude) &&
          latitude > -90 &&
          latitude < 90 &&
          longitude >= -180 &&
          longitude <= 180 &&
          validTimeZone(timeZone);

        if (!complete) return null;
        return {
          name: locationInput.value.trim() || `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`,
          admin1: '',
          country: '',
          latitude,
          longitude,
          timezone: timeZone
        };
      };

      const parseBirthMoment = (location) => {
        if (!birthDate.value) {
          showError(config.copy.errorMissingDate);
          return null;
        }
        if (!birthTime.value) {
          showError(config.copy.errorMissingTime);
          return null;
        }

        const dateValues = birthDate.value.split('-').map(Number);
        const timeValues = birthTime.value.split(':').map(Number);
        const wall = {
          year: dateValues[0],
          month: dateValues[1],
          day: dateValues[2],
          hour: timeValues[0],
          minute: timeValues[1]
        };
        const checkDate = new Date(
          wall.year,
          wall.month - 1,
          wall.day,
          wall.hour,
          wall.minute
        );
        const validDate =
          wall.year >= 1900 &&
          checkDate.getFullYear() === wall.year &&
          checkDate.getMonth() === wall.month - 1 &&
          checkDate.getDate() === wall.day &&
          checkDate.getHours() === wall.hour &&
          checkDate.getMinutes() === wall.minute;

        if (!validDate) {
          showError(config.copy.errorInvalidDate);
          return null;
        }

        let candidates;
        try {
          candidates = wallTimeToUtc(wall, location.timezone);
        } catch {
          showError(config.copy.errorInvalidLocation);
          return null;
        }

        if (!candidates.length) {
          showError(config.copy.errorLocalTime);
          return null;
        }
        if (candidates[0] > Date.now()) {
          showError(config.copy.errorFutureDate);
          return null;
        }

        return {
          utcTimestamp: candidates[0],
          ambiguous: candidates.length > 1
        };
      };

      const renderProduct = (card, recommendation) => {
        const { product, context, reason } = recommendation;
        const image = card.querySelector('[data-product-image]');
        const imageLink = card.querySelector('[data-product-image-link]');
        const titleLink = card.querySelector('[data-product-title]');
        const button = card.querySelector('[data-product-button]');

        card.querySelector('[data-product-context]').textContent = context;
        card.querySelector('[data-product-reason]').textContent = reason;
        card.querySelector('[data-product-price]').textContent = product.price || '';
        titleLink.textContent = product.title;
        titleLink.href = product.url;
        imageLink.href = product.url;
        button.href = product.url;

        if (product.image) {
          image.src = product.image;
          image.alt = product.title;
          imageLink.hidden = false;
        } else {
          image.removeAttribute('src');
          image.alt = '';
          imageLink.hidden = true;
        }
        card.hidden = false;
      };

      const renderProducts = (sunKey, ascendantKey) => {
        const sunData = config.signs[sunKey];
        const ascendantData = config.signs[ascendantKey];
        const elementKey = elements[signOrder.indexOf(ascendantKey)];
        const elementData = config.elements[elementKey];
        const rawRecommendations = [
          {
            product: ascendantData.product,
            context: config.copy.productForAscendant,
            reason: replaceTokens(config.copy.productReasonAscendant, {
              SIGN: ascendantData.name
            })
          },
          {
            product: sunData.product,
            context: config.copy.productForSun,
            reason: replaceTokens(config.copy.productReasonSun, { SIGN: sunData.name })
          },
          {
            product: elementData.product,
            context: config.copy.productForElement,
            reason: replaceTokens(config.copy.productReasonElement, {
              ELEMENT: elementData.name
            })
          },
          {
            product: config.fallbackProduct,
            context: config.copy.productForElement,
            reason: replaceTokens(config.copy.productReasonElement, {
              ELEMENT: elementData.name
            })
          }
        ];
        const seenUrls = new Set();
        const recommendations = rawRecommendations.filter(({ product }) => {
          if (!productHasContent(product) || seenUrls.has(product.url)) return false;
          seenUrls.add(product.url);
          return true;
        });

        productCards.forEach((card) => {
          card.hidden = true;
        });
        recommendations.slice(0, productCards.length).forEach((recommendation, index) => {
          renderProduct(productCards[index], recommendation);
        });
        root.querySelector('[data-products-section]').hidden = recommendations.length === 0;
      };

      const renderResult = (location, moment, positions) => {
        const sunIndex = Math.floor(positions.sunLongitude / 30);
        const ascendantIndex = Math.floor(positions.ascendant / 30);
        const sunKey = signOrder[sunIndex];
        const ascendantKey = signOrder[ascendantIndex];
        const sunData = config.signs[sunKey];
        const ascendantData = config.signs[ascendantKey];
        const sunElement = elements[sunIndex];
        const ascendantElement = elements[ascendantIndex];
        const elementData = config.elements[ascendantElement];
        const label = locationLabel(location);
        const cuspDistance = Math.min(
          positions.ascendant % 30,
          30 - (positions.ascendant % 30)
        );

        root.querySelector('[data-result-title]').textContent = replaceTokens(
          config.copy.resultPattern,
          { SUN: sunData.name, ASCENDANT: ascendantData.name }
        );
        root.querySelector('[data-result-location]').textContent = replaceTokens(
          config.copy.locationPattern,
          { LOCATION: label }
        );
        root.querySelector('[data-pair-description]').textContent =
          config.pairs[`${sunElement}_${ascendantElement}`] || '';
        root.querySelector('[data-sun-glyph]').textContent = glyphs[sunIndex];
        root.querySelector('[data-sun-name]').textContent = sunData.name;
        root.querySelector('[data-sun-degree]').textContent = replaceTokens(
          config.copy.degreePattern,
          { DEGREE: formattedDegree(positions.sunLongitude), SIGN: sunData.name }
        );
        root.querySelector('[data-ascendant-glyph]').textContent = glyphs[ascendantIndex];
        root.querySelector('[data-ascendant-name]').textContent = ascendantData.name;
        root.querySelector('[data-ascendant-degree]').textContent = replaceTokens(
          config.copy.degreePattern,
          { DEGREE: formattedDegree(positions.ascendant), SIGN: ascendantData.name }
        );
        root.querySelector('[data-profile]').textContent = ascendantData.profile;
        root.querySelector('[data-strengths]').textContent = ascendantData.strengths;
        root.querySelector('[data-advice]').textContent = ascendantData.advice;
        root.querySelector('[data-element]').textContent = elementData.name;
        root.querySelector('[data-stones]').textContent = ascendantData.stones;
        root.querySelector('[data-colors]').textContent = ascendantData.colors;
        root.querySelector('[data-cusp-warning]').hidden = cuspDistance >= 1;
        root.querySelector('[data-approximate-warning]').hidden = !approximateTime.checked;
        root.querySelector('[data-ambiguous-warning]').hidden = !moment.ambiguous;
        root.querySelector('[data-copy-status]').textContent = '';

        renderProducts(sunKey, ascendantKey);
        result.hidden = false;
        lastResult = { sun: sunData.name, ascendant: ascendantData.name };

        document.dispatchEvent(
          new CustomEvent('karmashop:ascendant-calculated', {
            detail: {
              sunSign: sunKey,
              ascendant: ascendantKey,
              element: ascendantElement
            }
          })
        );
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'ascendant_calculated',
            sun_sign: sunKey,
            ascendant_sign: ascendantKey,
            ascendant_element: ascendantElement
          });
        }
      };

      const resultShareText = () =>
        replaceTokens(config.copy.shareText, {
          SUN: lastResult.sun,
          ASCENDANT: lastResult.ascendant
        });

      const copyResult = async () => {
        if (!lastResult) return;
        const text = `${resultShareText()} ${window.location.href}`;
        try {
          await navigator.clipboard.writeText(text);
          root.querySelector('[data-copy-status]').textContent = config.copy.shareSuccess;
        } catch {
          const textArea = document.createElement('textarea');
          textArea.value = text;
          textArea.setAttribute('readonly', '');
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
          root.querySelector('[data-copy-status]').textContent = config.copy.shareSuccess;
        }
      };

      locationInput.addEventListener('input', () => {
        clearTimeout(searchTimer);
        searchRequest += 1;
        searchIndicator.classList.remove('is-loading');
        selectedLocation = null;
        selectedLocationBox.hidden = true;
        locationStatus.textContent = '';
        suggestions = [];
        closeSuggestions();

        const query = locationInput.value.trim();
        if (query.length < 3) return;
        searchTimer = window.setTimeout(() => searchLocations(query), 350);
      });

      locationInput.addEventListener('keydown', (event) => {
        if (locationList.hidden) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActiveSuggestion(activeSuggestion + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActiveSuggestion(activeSuggestion - 1);
        } else if (event.key === 'Enter' && activeSuggestion >= 0) {
          event.preventDefault();
          applyLocation(suggestions[activeSuggestion]);
        } else if (event.key === 'Escape') {
          closeSuggestions();
        }
      });

      locationInput.addEventListener('blur', () => {
        window.setTimeout(closeSuggestions, 120);
      });

      [latitudeInput, longitudeInput, timezoneInput].forEach((input) => {
        input.addEventListener('input', () => {
          selectedLocation = null;
          selectedLocationBox.hidden = true;
          clearError();
        });
      });

      [birthDate, birthTime].forEach((input) => {
        input.addEventListener('input', clearError);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clearError();
        setLoading(true);

        window.setTimeout(() => {
          const location = selectedLocation || manualLocation();
          if (!location) {
            const manualHasValue =
              latitudeInput.value || longitudeInput.value || timezoneInput.value.trim();
            showError(
              manualHasValue
                ? config.copy.errorInvalidLocation
                : config.copy.errorMissingLocation
            );
            setLoading(false);
            return;
          }

          const moment = parseBirthMoment(location);
          if (!moment) {
            setLoading(false);
            return;
          }

          const positions = astronomicalPositions(
            moment.utcTimestamp,
            Number(location.latitude),
            Number(location.longitude)
          );
          renderResult(location, moment, positions);
          setLoading(false);
          result.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 30);
      });

      root.querySelector('[data-share-result]').addEventListener('click', async () => {
        if (!lastResult) return;
        if (navigator.share) {
          try {
            await navigator.share({
              title: document.title,
              text: resultShareText(),
              url: window.location.href
            });
          } catch {
            return;
          }
        } else {
          await copyResult();
        }
      });

      root.querySelector('[data-copy-result]').addEventListener('click', copyResult);

      root.querySelector('[data-start-over]').addEventListener('click', () => {
        result.hidden = true;
        lastResult = null;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        birthDate.focus({ preventScroll: true });
      });
    };

    document.querySelectorAll('[data-ascendant-calculator]').forEach(initAscendantCalculator);
    document.addEventListener('shopify:section:load', (event) => {
      initAscendantCalculator(event.target.querySelector('[data-ascendant-calculator]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-zodiac-duo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ks-zodiac-duo')) {
  customElements.define('ks-zodiac-duo', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const config = JSON.parse(this.querySelector('[data-kz-config]').textContent);
      const variants = config.variants;
      const text = config.texts;
      const choices = [...this.querySelectorAll('[data-choice]')];
      const form = this.querySelector('[data-duo-form]');
      const submit = this.querySelector('[data-submit]');
      let originalLabel = submit.textContent;
      const error = this.querySelector('[data-error]');
      let busy = false;
      let added = false;
      let resultVariant;
      const localizeValidation = (fields,message) => fields.forEach(field=>{
        field.addEventListener('invalid',()=>field.setCustomValidity(message));
        ['input','change'].forEach(eventName=>field.addEventListener(eventName,()=>field.setCustomValidity('')));
      });
      localizeValidation(choices,text.select_error);
      const extraContainer=this.querySelector('[data-extra-choices]');
      const addExtra=this.querySelector('[data-add-extra]');
      const summary=this.querySelector('[data-order-summary]');
      const allChoices=()=>[...choices,...extraContainer.querySelectorAll('[data-extra-choice]')];
      const money=value=>new Intl.NumberFormat(config.locale || 'ro-RO',{style:'currency',currency:config.currency || 'RON'}).format(value/100);
      const refreshOffer=()=>{
        const count=allChoices().length,price=money(count*config.unitPrice);
        extraContainer.querySelectorAll('.kz-extra-row').forEach((row,i)=>{
          const n=i+3,select=row.querySelector('select'),label=row.querySelector('label');
          select.id='kz-extra-'+this.id+'-'+n;select.name='items['+(n-1)+'][id]';
          row.querySelector('[data-extra-quantity]').name='items['+(n-1)+'][quantity]';
          label.htmlFor=select.id;label.textContent=text.extra_label.replace('__NUMBER__',n);
          row.querySelector('[data-extra-number]').textContent=String(n).padStart(2,'0');
        });
        summary.textContent=text.total_label.replace('__COUNT__',count).replace('__PRICE__',price);
        summary.hidden=false;
        originalLabel=text.cta_many.replace('__COUNT__',count).replace('__PRICE__',price);
        if(!busy && !added)submit.textContent=originalLabel;
      };
      addExtra.hidden=false;
      addExtra.addEventListener('click',()=>{
        if(busy || added)return;
        const fragment=this.querySelector('[data-extra-template]').content.cloneNode(true);
        const row=fragment.querySelector('.kz-extra-row'),select=row.querySelector('select');
        localizeValidation([select],text.select_error);
        select.addEventListener('change',()=>{error.hidden=true;});
        row.querySelector('[data-remove-extra]').addEventListener('click',()=>{
          if(busy || added)return;
          row.remove();refreshOffer();error.hidden=true;addExtra.focus({preventScroll:true});
        });
        extraContainer.appendChild(fragment);refreshOffer();select.focus({preventScroll:true});
      });
      refreshOffer();

      const getVariant = select => variants.find(v => String(v.id) === select.value);
      const update = (select,index) => {
        select.setCustomValidity('');
        const v = getVariant(select);
        if (!v) return;
        const img = this.querySelector(index === 0 ? '[data-hero="first"]' : '[data-hero="second"]');
        img.removeAttribute('srcset'); img.src = v.image; img.alt = v.title;
        if (index === 0) {
          const url = new URL(window.location.href); url.searchParams.set('variant',v.id); history.replaceState({},'',url);
        }
        error.hidden = true;
      };
      choices.forEach((select,index) => select.addEventListener('change',()=>update(select,index)));
      this.querySelectorAll('[data-pick]').forEach(button => button.addEventListener('click',()=>{
        choices[0].value=button.dataset.pick; update(choices[0],0);
      }));
      const cartRetry=this.querySelector('[data-cart-link]');
      const getDrawer=()=>{const drawer=document.querySelector('m-cart-drawer');if(!drawer || typeof drawer.renderContents!=='function')throw new Error(text.drawer_error);return drawer;};
      const renderDrawer=async(data,trigger=submit)=>{
        const drawer=getDrawer();
        if(!data?.sections?.['cart-drawer']){
          const url=new URL(window.location.href);url.searchParams.set('sections','cart-drawer');
          const response=await fetch(url.pathname+url.search,{headers:{Accept:'application/json'}});
          if(!response.ok)throw new Error(text.verify_error);
          data={sections:await response.json()};
        }
        if(!data.sections?.['cart-drawer'])throw new Error(text.verify_error);
        drawer.setActiveElement(trigger);
        drawer.renderContents(data);
        if(window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate){window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate,{...data,source:'ks-zodiac-duo'});}
        fetch(this.dataset.cartRead,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(cart=>{if(cart)drawer.updateCartCount(cart.item_count);}).catch(()=>{});
      };
      cartRetry.addEventListener('click',async()=>{
        if(busy)return;busy=true;cartRetry.disabled=true;
        try{await renderDrawer();added=false;error.hidden=true;cartRetry.hidden=true;submit.disabled=false;submit.textContent=originalLabel;}
        catch(e){error.textContent=text.verify_error;error.hidden=false;}
        finally{busy=false;cartRetry.disabled=false;}
      });
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if (busy || added) return;
        error.hidden=true;
        const selected=allChoices().map(getVariant);
        if(selected.some(v=>!v || !v.available)){error.textContent=text.select_error;error.hidden=false;form.reportValidity();return;}
        const quantities=new Map();
        selected.forEach(v=>quantities.set(v.id,(quantities.get(v.id)||0)+1));
        if(selected.some(v=>v.tracked && !v.continueSelling && v.stock<quantities.get(v.id))){error.textContent=text.stock_error;error.hidden=false;return;}
        busy=true;submit.disabled=true;submit.textContent=text.busy;
        const items=[...quantities].map(([id,quantity])=>({id,quantity}));
        try {
          getDrawer();
          const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-drawer'],sections_url:window.location.pathname})});
          const data=await response.json();
          if(!response.ok) throw new Error(data.description || data.message || text.error);
          added=true;
          await renderDrawer(data);
          added=false;cartRetry.hidden=true;
        } catch(e) {
          error.textContent=added?text.verify_error:(e.message || text.error);error.hidden=false;
          cartRetry.hidden=!added;
        } finally {busy=false;if(!added){submit.disabled=false;submit.textContent=originalLabel;}}
      });

      const extraButtons=[...this.querySelectorAll('[data-upsell-add]')];
      const extraStatus=this.querySelector('[data-upsell-status]');
      const extraRetry=this.querySelector('[data-upsell-retry]');
      let extraPending=false,extraTrigger;
      extraButtons.forEach(button=>button.addEventListener('click',async()=>{
        if(busy || added || extraPending)return;
        busy=true;extraTrigger=button;extraStatus.hidden=true;extraRetry.hidden=true;
        const label=button.textContent;
        button.disabled=true;submit.disabled=true;button.textContent=text.upsell_busy;
        try{
          getDrawer();
          const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.upsellAdd),quantity:1}],sections:['cart-drawer'],sections_url:window.location.pathname})});
          const data=await response.json();
          if(!response.ok)throw new Error(text.upsell_error);
          extraPending=true;
          await renderDrawer(data,button);
          extraPending=false;extraStatus.textContent=text.upsell_added;
        }catch(e){
          extraStatus.textContent=extraPending?text.upsell_retry:text.upsell_error;
          extraRetry.hidden=!extraPending;
        }finally{
          busy=false;button.textContent=label;button.disabled=extraPending;submit.disabled=extraPending || added;extraStatus.hidden=false;
        }
      }));
      extraRetry.addEventListener('click',async()=>{
        if(busy)return;
        busy=true;extraRetry.disabled=true;
        try{
          await renderDrawer(undefined,extraTrigger);extraPending=false;extraRetry.hidden=true;
          extraTrigger.disabled=false;submit.disabled=added;extraStatus.textContent=text.upsell_added;
        }catch(e){extraStatus.textContent=text.upsell_retry;}
        finally{busy=false;extraRetry.disabled=false;}
      });
      const gallery=this.querySelector('[data-gallery]'),galleryImage=this.querySelector('[data-gallery-image]'),galleryStage=this.querySelector('.kz-gallery-stage'),zoomButton=this.querySelector('[data-gallery-zoom]');
      let galleryIndex=0,galleryTrigger;
      const setZoom=zoom=>{galleryStage.classList.toggle('is-zoomed',zoom);zoomButton.setAttribute('aria-pressed',String(zoom));galleryStage.scrollTop=0;galleryStage.scrollLeft=0;};
      const showImage=()=>{const v=variants[galleryIndex];galleryImage.src=v.zoom;galleryImage.alt=v.title;this.querySelector('[data-gallery-title]').textContent=v.title;this.querySelector('[data-gallery-count]').textContent=(galleryIndex+1)+' / '+variants.length;setZoom(false);};
      this.querySelectorAll('[data-gallery-hero]').forEach(button=>button.addEventListener('click',()=>{
        const index=button.dataset.galleryHero==='first'?0:1;
        const v=getVariant(choices[index]);
        const hero=button.querySelector('img');
        galleryIndex=v?variants.indexOf(v):variants.findIndex(item=>item.title===hero.alt || hero.alt.includes(item.title));
        if(galleryIndex<0)galleryIndex=index===0?0:7;
        galleryTrigger=button;showImage();gallery.showModal();document.documentElement.classList.add('kz-gallery-open');
      }));
      const moveImage=direction=>{galleryIndex=(galleryIndex+direction+variants.length)%variants.length;showImage();};
      this.querySelector('[data-gallery-prev]').addEventListener('click',()=>moveImage(-1));
      this.querySelector('[data-gallery-next]').addEventListener('click',()=>moveImage(1));
      this.querySelector('[data-gallery-close]').addEventListener('click',()=>gallery.close());
      const toggleZoom=()=>setZoom(!galleryStage.classList.contains('is-zoomed'));
      zoomButton.addEventListener('click',toggleZoom);galleryImage.addEventListener('click',toggleZoom);
      gallery.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();moveImage(event.key==='ArrowRight'?1:-1);}});
      gallery.addEventListener('click',event=>{if(event.target===gallery){const r=gallery.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)gallery.close();}});
      gallery.addEventListener('close',()=>{document.documentElement.classList.remove('kz-gallery-open');galleryTrigger?.focus({preventScroll:true});});
      const calc=this.querySelector('[data-calculator]'),result=this.querySelector('[data-result]'),resultTitle=this.querySelector('[data-result-title]'),resultText=this.querySelector('[data-result-text]'),applyWrap=this.querySelector('[data-apply-wrap]');
      const yearInput=this.querySelector('#kz-year'),monthInput=this.querySelector('#kz-month'),dayInput=this.querySelector('#kz-day');
      localizeValidation([yearInput,monthInput,dayInput],text.birth_error);
      const updateDays=()=>{const y=Number(yearInput.value),m=Number(monthInput.value);const days=y&&m?new Date(Date.UTC(y,m,0)).getUTCDate():31;[...dayInput.options].forEach(o=>{o.disabled=Number(o.value)>days;});if(Number(dayInput.value)>days)dayInput.value='';result.hidden=true;resultVariant=null;};
      yearInput.addEventListener('input',updateDays);monthInput.addEventListener('change',updateDays);dayInput.addEventListener('change',()=>{result.hidden=true;resultVariant=null;});
      calc.addEventListener('submit',event=>{
        event.preventDefault(); result.hidden=false;applyWrap.hidden=true;resultVariant=null;
        const y=Number(yearInput.value),m=Number(monthInput.value),d=Number(dayInput.value),date=new Date(Date.UTC(y,m-1,d,12));
        const today=new Date();const todayUTC=Date.UTC(today.getFullYear(),today.getMonth(),today.getDate(),12);
        if(y<1901||date.getUTCFullYear()!==y||date.getUTCMonth()!==m-1||date.getUTCDate()!==d||date.getTime()>todayUTC){resultTitle.textContent=text.birth_error;resultText.textContent='';return;}
        try{
          const formatter=new Intl.DateTimeFormat('en-u-ca-chinese',{year:'numeric',timeZone:'Asia/Shanghai'});
          if(formatter.resolvedOptions().calendar!=='chinese')throw new Error();
          const lunarYear=Number(formatter.formatToParts(date).find(p=>p.type==='relatedYear')?.value);
          if(!Number.isInteger(lunarYear))throw new Error();
          const index=((lunarYear-4)%12+12)%12;
          const zodiacNames=['Șobolan','Bivol','Tigru','Iepure','Dragon','Șarpe','Cal','Capră','Maimuță','Cocoș','Câine','Mistreț'];
          resultVariant=variants.find(v=>v.title===zodiacNames[index]);
          resultTitle.textContent=text.result.replace('__ZODIAC__',zodiacNames[index]);resultText.textContent=text.result_year.replace('__YEAR__',lunarYear);applyWrap.hidden=!resultVariant?.available;
        }catch(e){resultTitle.textContent=text.calc_error;resultText.textContent='';}
      });
      this.querySelectorAll('[data-apply]').forEach(button=>button.addEventListener('click',()=>{
        if(!resultVariant?.available)return;
        const index=Number(button.dataset.apply)-1;choices[index].value=String(resultVariant.id);update(choices[index],index);resultText.textContent=text.applied;
        choices[index].scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});choices[index].focus({preventScroll:true});
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucky-numbers-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toDateInputValue = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const reduceNumber = (number) => {
      let value = Math.abs(number);
      while (value > 9) {
        value = String(value)
          .split('')
          .reduce((sum, digit) => sum + Number(digit), 0);
      }
      return value || 9;
    };

    const randomUnit = () => {
      if (window.crypto && window.crypto.getRandomValues) {
        const value = new Uint32Array(1);
        window.crypto.getRandomValues(value);
        return value[0] / 4294967296;
      }
      return Math.random();
    };

    const zodiacKey = (month, day) => {
      if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return 'berbec';
      if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return 'taur';
      if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return 'gemeni';
      if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return 'rac';
      if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return 'leu';
      if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return 'fecioara';
      if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return 'balanta';
      if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return 'scorpion';
      if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return 'sagetator';
      if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return 'capricorn';
      if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return 'varsator';
      return 'pesti';
    };

    const weightedNumbers = (personalDay) => {
      const pool = Array.from({ length: 49 }, (_, index) => index + 1);
      const result = [];

      while (result.length < 6) {
        const weights = pool.map((number) => (reduceNumber(number) === personalDay ? 3 : 1));
        const total = weights.reduce((sum, weight) => sum + weight, 0);
        let target = randomUnit() * total;
        let selectedIndex = 0;

        for (let index = 0; index < pool.length; index += 1) {
          target -= weights[index];
          if (target <= 0) {
            selectedIndex = index;
            break;
          }
        }

        result.push(pool[selectedIndex]);
        pool.splice(selectedIndex, 1);
      }

      return result.sort((first, second) => first - second);
    };

    const sameNumbers = (first, second) =>
      first.length === second.length && first.every((number, index) => number === second[index]);

    const initLuckyNumbers = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const slot = document.getElementById('lucky-numbers-calculator-slot');
      if (slot && !slot.contains(root)) {
        const wrapper = root.closest('.shopify-section') || root;
        slot.appendChild(wrapper);
      }

      const form = root.querySelector('[data-lucky-form]');
      const input = root.querySelector('[data-birth-date]');
      const error = root.querySelector('[data-lucky-error]');
      const result = root.querySelector('[data-lucky-result]');
      const balls = root.querySelector('.lucky-numbers__balls');
      const numberNodes = [...root.querySelectorAll('[data-lucky-number]')];
      const personalDayNode = root.querySelector('[data-personal-day]');
      const zodiacNode = root.querySelector('[data-zodiac-name]');
      const reasonNode = root.querySelector('[data-product-reason]');
      const productCard = root.querySelector('[data-product-card]');
      const productImage = root.querySelector('[data-product-image]');
      const productTitle = root.querySelector('[data-product-title]');
      const productPrice = root.querySelector('[data-product-price]');
      const productLink = root.querySelector('[data-product-link]');
      const todayLabel = root.querySelector('[data-today-label]');
      const copyStatus = root.querySelector('[data-copy-status]');
      const productData = JSON.parse(root.querySelector('[data-lucky-products]').textContent);
      let currentBirthDate = null;
      let currentNumbers = [];

      input.max = toDateInputValue(new Date());

      const showError = (message) => {
        error.textContent = message;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
      };

      const clearError = () => {
        error.textContent = '';
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      };

      const parseBirthDate = () => {
        if (!input.value) {
          showError(root.dataset.errorMissing);
          return null;
        }

        const values = input.value.split('-').map(Number);
        const birthDate = new Date(values[0], values[1] - 1, values[2]);
        const isExactDate =
          birthDate.getFullYear() === values[0] &&
          birthDate.getMonth() === values[1] - 1 &&
          birthDate.getDate() === values[2];

        if (!isExactDate || values[0] < 1900) {
          showError(root.dataset.errorInvalid);
          return null;
        }

        const today = new Date();
        today.setHours(23, 59, 59, 999);
        if (birthDate > today) {
          showError(root.dataset.errorFuture);
          return null;
        }

        clearError();
        return birthDate;
      };

      const renderProduct = (product) => {
        if (!product || !product.url) {
          productCard.hidden = true;
          return;
        }

        productCard.hidden = false;
        productTitle.textContent = `${root.dataset.productTitlePrefix} ${product.name}`;
        productPrice.textContent = product.price;
        productLink.href = product.url;
        if (product.image) {
          productImage.src = product.image;
          productImage.alt = product.title;
          productImage.parentElement.hidden = false;
        } else {
          productImage.removeAttribute('src');
          productImage.alt = '';
          productImage.parentElement.hidden = true;
        }
      };

      const renderCombination = () => {
        if (!currentBirthDate) return;

        const today = new Date();
        const birthDigits = `${currentBirthDate.getFullYear()}${currentBirthDate.getMonth() + 1}${currentBirthDate.getDate()}`;
        const todayDigits = `${today.getFullYear()}${today.getMonth() + 1}${today.getDate()}`;
        const birthNumber = reduceNumber([...birthDigits].reduce((sum, digit) => sum + Number(digit), 0));
        const dayNumber = reduceNumber([...todayDigits].reduce((sum, digit) => sum + Number(digit), 0));
        const personalDay = reduceNumber(birthNumber + dayNumber);

        let nextNumbers = weightedNumbers(personalDay);
        let attempts = 0;
        while (sameNumbers(nextNumbers, currentNumbers) && attempts < 5) {
          nextNumbers = weightedNumbers(personalDay);
          attempts += 1;
        }
        currentNumbers = nextNumbers;

        numberNodes.forEach((node, index) => {
          node.textContent = String(currentNumbers[index]);
        });
        personalDayNode.textContent = String(personalDay);

        const key = zodiacKey(currentBirthDate.getMonth() + 1, currentBirthDate.getDate());
        const product = productData[key];
        zodiacNode.textContent = product.name;
        reasonNode.textContent = product.reason;
        renderProduct(product);

        todayLabel.textContent = new Intl.DateTimeFormat('ro-RO', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(today);

        result.hidden = false;
        copyStatus.textContent = '';
        balls.classList.remove('is-refreshing');
        window.requestAnimationFrame(() => balls.classList.add('is-refreshing'));
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        currentBirthDate = parseBirthDate();
        if (!currentBirthDate) return;
        renderCombination();
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      root.querySelector('[data-regenerate]').addEventListener('click', renderCombination);

      root.querySelector('[data-copy-numbers]').addEventListener('click', async () => {
        if (!currentNumbers.length) return;
        try {
          await navigator.clipboard.writeText(currentNumbers.join(', '));
          copyStatus.textContent = root.dataset.copySuccess;
        } catch {
          copyStatus.textContent = root.dataset.copyFailed;
        }
      });

      input.addEventListener('input', clearError);
    };

    document.querySelectorAll('[data-lucky-numbers]').forEach(initLuckyNumbers);
    document.addEventListener('shopify:section:load', (event) => {
      initLuckyNumbers(event.target.querySelector('[data-lucky-numbers]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
